var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import React from "react";
const SvgIcIgnoreList = _ref => {
  let {
    svgRef,
    title,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "66px",
    height: "86px",
    viewBox: "0 0 66 86",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Desktop",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "1.2.-Import",
    transform: "translate(-1037.000000, -314.000000)",
    fill: "#E44D5F",
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-5",
    transform: "translate(35.000000, 169.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Mask-2-Copy-12",
    transform: "translate(875.000000, 100.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "icons8-resume",
    transform: "translate(128.000000, 46.000000)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M2,0 L62,0 C63.1045695,-2.02906125e-16 64,0.8954305 64,2 L64,82 C64,83.1045695 63.1045695,84 62,84 L2,84 C0.8954305,84 1.3527075e-16,83.1045695 0,82 L0,2 C-1.3527075e-16,0.8954305 0.8954305,2.02906125e-16 2,0 Z",
    id: "Path",
    stroke: "#E44D5F",
    strokeWidth: 2,
    fillOpacity: 0.15
  }), /*#__PURE__*/React.createElement("path", {
    d: "M19,26 C25.508,26 28,30.658 28,30.658 L28,30.658 L28,34 L10,34 L10,30.658 C10,30.658 12.49,26 19,26 Z M54,28 L54,32 L36,32 L36,28 L54,28 Z M19,14 C21.762,14 24,16.238 24,19 C24,21.76 21.762,24 19,24 C16.238,24 14,21.76 14,19 C14,16.238 16.238,14 19,14 Z M54,18 L54,22 L36,22 L36,18 L54,18 Z",
    id: "Combined-Shape"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M54,66 L54,70 L44,70 L44,66 L54,66 Z M38,66 L38,70 L10,70 L10,66 L38,66 Z M54,56 L54,60 L44,60 L44,56 L54,56 Z M32,56 L32,60 L10,60 L10,56 L32,56 Z M54,46 L54,50 L44,50 L44,46 L54,46 Z M38,46 L38,50 L10,50 L10,46 L38,46 Z",
    id: "Combined-Shape",
    opacity: 0.5
  }))))))));
};
const ForwardRef = /*#__PURE__*/React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(SvgIcIgnoreList, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/ic-ignore-list.9d99134c.svg";
export { ForwardRef as ReactComponent };